import React from 'react';
import { Switch as MaterialUiSwitch, SwitchProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';
import { ISharedFormProps } from '../ISharedFormProps';

interface ISwitchProps extends SwitchProps, ISharedProps, ISharedFormProps {}

export const Switch = ({ ...props }: ISwitchProps) => (
  <MaterialUiSwitch
    color="primary"
    name={props.field?.name}
    onChange={props.field?.onChange}
    onBlur={props.field?.onBlur}
    {...props}
  />
);
